import { bidPaymentStatusesEnum, distributionBidPaymentTypesEnum } from "helpers/enums";
import moment from "moment";
import { applyBidPayment } from "sources/books/bids/closeBids";
import { applyPayment as applyDistributionBidPayment } from "sources/books/distributionBids";

export const applyReportPayment = (row, payment, isAccountsPayable) => {
    if (row.isDistributionBid) {
        return applyDistributionBidPayment({
            distributionBidId: row.bidId,
            paymentType: isAccountsPayable
                ? distributionBidPaymentTypesEnum.HiredCar
                : distributionBidPaymentTypesEnum.Customer,
            payment,
        });
    }
    return applyBidPayment({ bidId: row.bidId, payment });
};

export const paymentOverdueDays = ({ factPaymentDate, planPaymentDate }) => {
    if (!planPaymentDate || !moment(planPaymentDate, "YYYY-MM-DD", true).isValid()) {
        return 0;
    }
    return (factPaymentDate ? moment(factPaymentDate, "YYYY-MM-DD") : moment().startOf("day")).diff(
        moment(planPaymentDate, "YYYY-MM-DD"),
        "days",
    );
};

export const paymentOverdueState = (payment) => {
    const overdueDays = paymentOverdueDays(payment);
    return {
        overdueDays,
        isPaymentOverdue: payment.paymentStatus !== bidPaymentStatusesEnum.Paid && overdueDays > 0,
    };
};
